import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/config";

import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
